import { render } from "./BrandBar.vue?vue&type=template&id=ba64abf4"
import script from "./BrandBar.vue?vue&type=script&lang=js"
export * from "./BrandBar.vue?vue&type=script&lang=js"

import "./BrandBar.vue?vue&type=style&index=0&id=ba64abf4&lang=postcss"

import exportComponent from "/var/vhosts/unrisd-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__